<script>
import ScreenLang from "./components/FullScreenLang.vue";
import ScreenAca from "./components/FullScreenAca.vue";
export default {
    components: {
        ScreenLang,
        ScreenAca,
    },
    data() {
        return {
            ActiveTab: "",
            isActive: false,
        };
    },
    computed: {
        ag() {
            return this.$parent.ag;
        },
        wid() {
            return this.$parent.wid;
        },
        Setting() {
            return this.$parent.Settings;
        },
        Translation() {
            return this.$parent.Translation;
        },
    },
};
</script>
<template>
    <section id="screen">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1 class="screen-title text-dark fw-700 my-5 text-center">Hangi program ile ilgileniyorsunuz?</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <ScreenLang />
                </div>
                <div class="col-md-6">
                    <ScreenAca />
                </div>
            </div>
        </div>
    </section>
</template>
